<template>

    <div class="has-margin-top">
        <div class="bp-panel has-no-title" style="min-height: auto">
            <div class="panel-content">
                <div class="columns has-seperating-borders">
                    <div class="column">
                        <div>
                            <h4>{{publication.website.name}}</h4>
                            <p class="is-small-text"
                               :class="{
                                'is-text-red': publication.status === 'notPublished',
                                'is-text-yellow' : publication.status === 'staged',
                                'is-text-blue': publication.status === 'published'
                            }"
                            >{{getStatusText(publication)}}</p>
                            <p class="is-small-text" v-if="publication.lastError" style="color: #e3342f">{{publication.lastError}}</p>
                        </div>
                        <div class="is-small-text mt-1">
                            <span
                                v-for="locale in publication.website.locales"
                                :key="locale"
                                class="tag is-rounded"
                                style="margin-right: 4px"
                                :class="publication.publishedLocales.includes(locale) ? 'is-primary' : 'is-light'"
                            >{{locale}}</span>
                        </div>
                        <div class="is-small-text">
                            <a class="is-text-link-color" target="_blank" :href="getUrl(publication)">Ansehen</a>
                        </div>
                        <div class="level level-left mt-4">
                            <div class="control level-item">
                                <button
                                    v-bind:class="{ 'is-loading' : loadingId === publication.id }"
                                    :disabled="loadingId !== null"
                                    @click="publish(publication, 'stage')"
                                    class="button is-full-width">
                                    <i class="material-icons">sync</i> Auf Testseite
                                </button>
                            </div>
                            <div class="control level-item">
                                <button
                                    v-bind:class="{ 'is-loading' : loadingId === publication.id }"
                                    :disabled="loadingId !== null"
                                    @click="publish(publication, 'publish')"
                                    class="button is-full-width is-primary">
                                    <i class="material-icons">public</i> Veröffentlichen
                                </button>
                            </div>
                            <div class="control level-item" v-if="publication.status === 'published' || publication.status === 'staged'">
                                <button
                                    v-bind:class="{ 'is-loading' : loadingId === publication.id }"
                                    :disabled="loadingId !== null"
                                    @click="unpublish(publication)"
                                    class="button is-full-width is-danger">
                                    <i class="material-icons">delete</i> Entfernen
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import moment from 'moment';
import Mixin from '../../tab';
import {edit} from "@api";
import {notifyError, notifySuccess} from "@components/Notification";

export default {
    mixins: [ Mixin ],

    props: {
        component: {
            type: Object,
            required: true,
        }
    },

    data: function() {
        return {
            loadingId: null,
        }
    },

    computed: {
        publication: function () {
            return this.component.props.publication;
        },
    },

    methods: {
        getUrl(publication) {
            let base = publication.website.previewUrl || publication.website.baseUrl;
            return base + '/reisen/' + publication.slug;
        },

        getStatusText(publication) {
            if(publication.status === 'published') {
                return 'Veröffentlicht | ' + this.formatDate(publication.publishedAt);
            }
            if(publication.status === 'staged') {
                return 'Auf Testseite veröffentlicht | ' + this.formatDate(publication.stagedAt);
            }
            return 'Reise nicht veröffentlicht';
        },

        formatDate(date) {
            return date ? moment(date, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY HH:mm:ss') : '-';
        },

        replacePublication(publication) {
            this.$emit('buttonAction', {action: 'updatePublication', element: publication});
        },

        publish(publication, action) {
            if(action === 'publish' && !confirm('Soll die Reise wirklich auf ' + publication.website.name + ' veröffentlicht werden?')) {
                return;
            }
            this.loadingId = publication.id;
            edit('website_publications/' + publication.id + '/publish', {}, {
                action: action,
            }).then(response => {
                this.replacePublication(response.data);
                notifySuccess('Die Aktion wurde erfolgreich durchgeführt!');
            }, error => {
                notifyError('Die Aktion konnte nicht durchgeführt werden! Server Error!');
            }).then(() => { this.loadingId = null; });
        },

        unpublish(publication) {
            if(!confirm('Soll die Reise wirklich von ' + publication.website.name + ' entfernt werden?')) {
                return;
            }
            this.loadingId = publication.id;
            edit('website_publications/' + publication.id + '/unpublish', {}).then(response => {
                this.replacePublication(response.data);
                notifySuccess('Die Aktion wurde erfolgreich durchgeführt!');
            }, error => {
                notifyError('Die Aktion konnte nicht durchgeführt werden! Server Error!');
            }).then(() => { this.loadingId = null; });
        },
    },

}
</script>
